import React from "react"
import { Field, ErrorMessage } from "formik"

function KCSelect(props) {
  const { label, inputClass, name, options, referalKey,referalValue, ...rest } = props;
  return (
    <>
      <Field as="select" id={name} name={name} {...rest} className={inputClass}>
        {options.map(option => {
          return (
            <option key={option[referalKey]} value={option[referalValue]}>
              {option[referalKey]}
            </option>
          )
        })}
      </Field>
      <ErrorMessage name={name} />
    </>
  )
}

export default KCSelect